import { IconSpeakerphone } from '@tabler/icons-react';
import { Link, useLocation } from 'react-router-dom';
import { useMyAnnouncements } from '../../api/operations';
import { useSession } from '../../app/session';
import ops from './operations.module.css';

/**
 * The shell banner (spec §6): important unread and must-acknowledge unacknowledged
 * announcements, until read / acknowledged. Not dismissable. Fetched on navigation/focus with a
 * 60s stale time; no polling.
 */
export function AnnouncementsBanner() {
  const { signedIn } = useSession();
  const { pathname } = useLocation();
  const q = useMyAnnouncements(signedIn);
  const items = q.data?.banner ?? [];
  const first = items[0];
  if (!first || pathname === `/announcements/${first.id}`) return null;
  const toAck = first.mustAcknowledge && !first.acknowledgedAt;
  return (
    <div className={ops.banner} data-ack={toAck || undefined} role="status">
      <IconSpeakerphone size={18} stroke={2} aria-hidden="true" />
      <span style={{ flex: '1 1 auto', minWidth: 0 }}>
        {toAck ? 'Please acknowledge: ' : 'Important: '}
        <Link to={`/announcements/${first.id}`}>{first.title}</Link>
      </span>
      {items.length > 1 && (
        <Link to="/announcements" className={ops.bannerMore}>
          +{items.length - 1} more
        </Link>
      )}
    </div>
  );
}
